var naturesEsLatam = {
    "100": "Fuerte",
    "101": "Huraña",
    "102": "Audaz",
    "103": "Firme",
    "104": "Pícara",
    "105": "Osada",
    "106": "Dócil",
    "107": "Relajada",
    "108": "Agitada",
    "109": "Descuidada",
    "110": "Miedosa",
    "111": "Activa",
    "112": "Seria",
    "113": "Alegre",
    "114": "Ingenua",
    "115": "Modesta",
    "116": "Cordial",
    "117": "Apacible",
    "118": "Tímida",
    "119": "Alocada",
    "120": "Serena",
    "121": "Amable",
    "122": "Grosera",
    "123": "Cauta",
    "124": "Extravagante"
};
export default naturesEsLatam;